import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import BModal from "./index";
import Providers from "@/providers/AntdProvider";
// 全局管理器
class BModalManager {
    constructor() {
        this.container = null;
        this.root = null;
    }
    getContainer() {
        if (!this.container) {
            this.container = document.createElement("div");
            document.body.appendChild(this.container);
        }
        return this.container;
    }
    getRoot() {
        this.root ?? (this.root = createRoot(this.getContainer()));
        return this.root;
    }
    open(props) {
        const BModalComponent = () => {
            const [visible, setVisible] = useState(true);
            const handleClose = () => {
                setVisible(false);
                // 延迟销毁，等待动画完成
                setTimeout(() => {
                    this.destroy();
                }, 300);
            };
            const handleOk = () => {
                props.onOk?.();
                handleClose();
            };
            const handleCancel = () => {
                props.onCancel?.();
                handleClose();
            };
            return (_jsx(Providers, { children: _jsx(BModal, { open: visible, onCancel: handleCancel, onOk: handleOk, content: props.content, children: props.children, okText: props.okText, cancelText: props.cancelText, width: props.width, title: props.title, footer: props.footer, closable: props.closable, maskClosable: props.maskClosable }) }));
        };
        this.getRoot().render(React.createElement(BModalComponent));
    }
    destroy() {
        if (this.root) {
            this.root.unmount();
            this.root = null;
        }
        if (this.container) {
            document.body.removeChild(this.container);
            this.container = null;
        }
    }
}
// 创建全局实例
const bModalManager = new BModalManager();
// 导出类似 message 的 API
export const modal = {
    open: (props) => {
        bModalManager.open(props);
    },
};
// 为了向后兼容，也导出 bModal
export const bModal = modal;
